/**
 * Global signed-out 401/403 Sentry suppress. Defaults on so deployed
 * environments that never set the NEXT_PUBLIC flag (PORTAL-1BT /
 * PORTAL-1AM after the #5589 unwind) do not page expected auth-loss
 * query errors. Set `NEXT_PUBLIC_SUPPRESS_SIGNED_OUT_QUERY_401=false`
 * to disable.
 */
export function isSuppressSignedOutQuery401Enabled(): boolean {
  return process.env.NEXT_PUBLIC_SUPPRESS_SIGNED_OUT_QUERY_401 !== 'false';
}
